import BasePopover, { PopoverProps as BaseProps } from 'antd/lib/popover'

export interface PopoverProps extends BaseProps {}

export function Popover(props: PopoverProps): JSX.Element {
  return (
    <>
      <BasePopover {...props} />
    </>
  )
}
